import React, { useRef, useState, useEffect } from 'react';
import SignatureCanvas from 'react-signature-canvas';




const logo = require("./../assets/img/logo.svg").default;
const demoImg = require("./../assets/img/demo-img.png");
const companyLogo = require("./../assets/img/company-logo.svg").default;


const PreviewForm = () => {

	const signatureRef = useRef();
  const [canvasSize, setCanvasSize] = useState({
    width: 650,
    height: 200,
  });

  const handleClear = () => {
    signatureRef.current.clear();
  };

  const handleSave = () => {
    const signatureData = signatureRef.current.toDataURL();
    // You can now save or use the signatureData as needed.
  };

  useEffect(() => {
    const handleResize = () => {
      const newCanvasSize = {
        width: window.innerWidth >= 890 ? 870 : '300',
        height: window.innerWidth >= 768 ? 200 : '130',
      };
      setCanvasSize(newCanvasSize);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initialize canvas size based on initial window width

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

	return (
		<div className='bodyMain'>

				<div className="previewPopup formPrvwPge">
					<div className='previewPopupInner'>
						
							
							<div className='lftPop'>
								<img src={logo} alt="image" />
							</div>
							<div className='rgtPop'>
								<h3><img src={companyLogo} alt="image" /></h3>
								<p>211 N. 13th Street, 9th Floor, Philadelphia,PA 19107, USA</p>
								<p><span>p:</span> 800.765.7111 <span>E:</span>info@cliqjewelry.com</p>
								<p>www.cliqjewelry.com</p>
							</div>

							<div className='jobDtls'>
								<h3><span>Job code:</span> JO-032271</h3>
								<h3><span>Date:</span> 07/08/2023</h3>
							</div>

							<div className='prvwForm'>
								<ul className='cstmr'>
									<li>
										<h3>Customer name:</h3>
										Harris Jeweler
									</li>
									<li>
										<h3>Insured Value:</h3>
										<input type='text' placeholder='Enter value (in dollars)' />
									</li>
									<li>
										<h3>Customer PO#</h3>
										Diane Meyer 664518-1
									</li>
									<li>
										
									</li>
									<li>
										<h3>Job description and Notes:</h3>
										Lorem Ipsum
									</li>
									<li className='fulWid'>
										<h3>Please see images below:</h3>
										<p><img src={demoImg} alt="image" className='viewImg' />
										<img src={demoImg} alt="image" className='viewImg' />
										<img src={demoImg} alt="image" className='viewImg' /></p>
									</li>
									
									<li className='HdnBck txtWid'>
										<h4>Item Type</h4>
									</li>
									<li className='HdnBck txtWid2'>
										<h4>Description</h4>
									</li>
									<li className='txtWid'>
										<h3>Items:</h3>
										Customer Item (1) + Installation Blank (1) +
CLIQ Installation Labor (1) + Return Scrap (1)
									</li>
									<li className='txtWid2'>
										<h3>Item SKU:</h3>
										000_7X2_6.75_14KY-S
									</li>
									<li className='txtWid'>
										<h3>Finger Size:</h3>
										6.75
									</li>
									<li className='txtWid2'>
										<h3>Metal:</h3>
										14KY-Superfit
									</li>
									
								</ul>
								<ul className='prctable'>
								<li className='shpTbl'>
										<h3>Shipping: <strong>TBD</strong></h3>
									</li>
									<li className='ttlTbl'>
										<h3>Total price: <strong>$1,505.00</strong></h3>
									</li>
								</ul>
							</div>

							

								

									

									<div className='signBox'>

<div className='signInner'>

<div>
<SignatureCanvas
        ref={signatureRef}
        canvasProps={{
			width: canvasSize.width,
			height: canvasSize.height,
			className: 'signatureCanvas',
		  }}
      />
      <button onClick={handleClear}>Clear</button>
      <button onClick={handleSave}>Save</button>
    </div>
</div>
<h4>Customer signature</h4>
<button className='continueBtn'>Submit</button>
										</div>

						</div>
						
					
				</div>
			

			
		</div>
	);
};

export default PreviewForm;
